import React from 'react';

import moment from 'moment';

export default translationsStore => ({
  width: '80px',
  className: 'createdAt',
  title: (
    <span>
      <div>{translationsStore.translate('lead.table.column.date.date')}</div>
      <div>{translationsStore.translate('lead.table.column.date.lead')}</div>
    </span>
  ),
  dataIndex: 'startDate',
  sorter: (a, b) => moment(a.startDate).diff(moment(b.startDate)),
  render: text => (
    <div>
      <div>
        {moment(text).format('DD')} {moment(text).format('MMM')}
      </div>
      <div>{moment(text).format('YYYY')}</div>
    </div>
  )
});
